import i18n from '../../../../../i18n';
import { fmt } from '../../../data/metrics';
import '../../../styles/drill-substance.css';

/** "18:00" for a clock hour (0–23). */
export function hourLabel(hour: number): string {
  return `${String(((hour % 24) + 24) % 24).padStart(2, '0')}:00`;
}

/** "18:00–19:00" for one clock hour. */
export function hourRange(hour: number): string {
  return `${hourLabel(hour)}–${hourLabel(hour + 1)}`;
}

/** Short weekday name for an ISO weekday (1 = Monday). */
export function weekdayLabel(isoWeekday: number): string {
  return i18n.t(`performance:drillPos.weekday.${isoWeekday}`);
}

/** Signed number with a leading + for gains. */
export function signed(v: number, digits = 1): string {
  const n = +v.toFixed(digits);
  return `${n > 0 ? '+' : ''}${n}`;
}

/** A plural string whose `{{n}}` is the locale-formatted count. */
export function countLabel(key: string, count: number, extra?: Record<string, unknown>): string {
  return i18n.t(key, { count, n: fmt.num(count), ...extra });
}
